import React, {Component} from "react";
import SvGraphics from "../../assets/SvGraphics";


class UploadedFilesForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    async componentDidMount() {
    }

    render() {
        let display = this.props.isSideBarOpen ? 'block' : 'none'
        let width = this.props.isSideBarOpen ? "600px" : "0px"
        let container_width = this.props.isSideBarOpen ? "100%" : "0px"
        let {t} = this.props
        let lang = localStorage.getItem('language');
        let {filesArr} = this.props
        return (
            <div className={"sidenav-complete"} style={{width: container_width, height: "100%"}}>
                <div className={"uploadFilesSidenav"}
                     style={{width: width, height: "100%", float: lang === "he" ? 'left' : 'right'}}>
                    <SvGraphics onClick={() => this.props.closeSideBar()} className={'close-bar-x'} svgname={'close'}
                                height={'15px'} width={'15px'} style={{
                        float: 'left',
                        top: '10px',
                        left: '10px',
                        position: 'absolute',
                        cursor: 'pointer'
                    }}/>
                    <div className={'uploadFiles-register-form-title container block'}>
                        <h3 className={'h-centered block uploadFilesTitle'}>{t('patientPage.uploadedFiles')} ({filesArr.length>0?filesArr.length:""})</h3>
                    </div>
                    <div style={{marginTop:'30px'}}>
                        {filesArr}
                    </div>
                </div>


            </div>
        );
    }
}

UploadedFilesForm.propTypes = {}

export default UploadedFilesForm

